export class SampleRate {

    public id: number;
    public name: string;
    public description: string;
    public filterValue: number;
    public displayName: string

    constructor(sampleRate: any = {}) {
        this.id = sampleRate.id || null;
        this.name = sampleRate.name || '';
        this.description = sampleRate.description || '';
        this.filterValue = sampleRate.filterValue || null ;
        this.displayName = sampleRate.name + ' - ' + sampleRate.filterValue;
    }
}
